import { render, staticRenderFns } from "./general-info-form.vue?vue&type=template&id=6df7eae6&scoped=true"
import script from "./general-info-form.vue?vue&type=script&lang=js"
export * from "./general-info-form.vue?vue&type=script&lang=js"
import style0 from "./general-info-form.vue?vue&type=style&index=0&id=6df7eae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df7eae6",
  null
  
)

export default component.exports